function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) {
        return descriptor.get.call(receiver);
    }
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) {
        descriptor.set.call(receiver, value);
    } else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to " + action + " private field on non-instance");
    }
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { MotivatorChart } from "../../../models";
import { attuned_theme } from "../../../styles/theme";
import { BarChart } from "echarts/charts";
import { GridComponent } from "echarts/components";
var ORIENTATION = {
    HORIZONTAL: 'HORIZONTAL',
    VERTICAL: 'VERTICAL'
};
var _labelAxis = /*#__PURE__*/ new WeakMap(), _valueAxis = /*#__PURE__*/ new WeakMap(), _percentageLabel = /*#__PURE__*/ new WeakMap(), _optionPresets = /*#__PURE__*/ new WeakMap();
/**
 * Bar chart representation of Motivator data set.
 * @class MotivatorsBarChart
 * @extends MotivatorChart
 */ export var MotivatorsBarChart = /*#__PURE__*/ function(MotivatorChart) {
    "use strict";
    _inherits(MotivatorsBarChart, MotivatorChart);
    function MotivatorsBarChart(_param) {
        _class_call_check(this, MotivatorsBarChart);
        var _this;
        var tmp = _param.options, orientation = (tmp === void 0 ? {} : tmp).orientation, _param_theme = _param.theme, theme = _param_theme === void 0 ? attuned_theme : _param_theme, _param_useMotivatorColors = _param.useMotivatorColors, useMotivatorColors = _param_useMotivatorColors === void 0 ? false : _param_useMotivatorColors, _param_data = _param.data, data = _param_data === void 0 ? [] : _param_data, _param_eventCallbacks = _param.eventCallbacks, eventCallbacks = _param_eventCallbacks === void 0 ? [] : _param_eventCallbacks, opts = _object_without_properties(_param.options, [
            "orientation"
        ]);
        _this = _call_super(this, MotivatorsBarChart, [
            theme,
            useMotivatorColors,
            [
                BarChart,
                GridComponent
            ],
            eventCallbacks
        ]), _class_private_field_init(_this, _labelAxis, {
            writable: true,
            value: void 0
        }), _class_private_field_init(_this, _valueAxis, {
            writable: true,
            value: void 0
        }), _class_private_field_init(_this, _percentageLabel, {
            writable: true,
            value: {
                position: 'right',
                formatter: [
                    '{m_percentage| {@percentage}%}'
                ].join('\n'),
                rich: {
                    m_percentage: _object_spread_props(_object_spread({}, _this.theme._components.barPercentageLabel.m_percentage), {
                        fontSize: 12
                    })
                }
            }
        }), _class_private_field_init(_this, _optionPresets, {
            writable: true,
            value: {
                VALUE_AXIS: {
                    type: 'value'
                },
                LABEL_AXIS: {
                    type: 'category',
                    triggerEvent: true,
                    axisLabel: {
                        show: true,
                        margin: 4,
                        width: 100,
                        lineHeight: 22,
                        overflow: 'truncate',
                        borderRadius: 5,
                        backgroundColor: _this.theme._components.barAxisLabel.backgroundColor,
                        formatter: [
                            '{m_image|} {m_label| {value}}'
                        ].join('\n'),
                        rich: {
                            // TODO add motivator icon
                            // m_image: {
                            //   align: 'left',
                            //   width: 30,
                            //   backgroundColor: {
                            //     image: autonomyIcon
                            //   }
                            // },
                            m_label: {
                                fontSize: 12,
                                align: 'right',
                                verticalAlign: 'middle',
                                height: 18,
                                padding: [
                                    6,
                                    4,
                                    6,
                                    4
                                ],
                                color: _this.theme._components.barAxisLabel.m_label.color
                            }
                        }
                    }
                }
            }
        });
        switch(orientation){
            case ORIENTATION.VERTICAL:
                _class_private_field_set(_this, _valueAxis, 'yAxis');
                _class_private_field_set(_this, _labelAxis, 'xAxis');
                break;
            default:
            case ORIENTATION.HORIZONTAL:
                _class_private_field_set(_this, _valueAxis, 'xAxis');
                _class_private_field_set(_this, _labelAxis, 'yAxis');
        }
        var _obj;
        // ** 2022.12.29 AC **
        // There's currently a bug with axisLabel using rich formatting
        // where label will be cut off even if `containerLabel` is set
        // to `true`. There's PR open for it, once that's merged we can
        // remove the explicit `left` positioning and set `width` to 100%.
        _this.options = _object_spread((_obj = {
            animation: true,
            tooltip: {
                trigger: 'item'
            },
            grid: {
                show: false,
                containLabel: true,
                top: 0,
                bot: 0,
                // width: '100%',
                height: '100%'
            },
            series: [
                {
                    type: 'bar',
                    barCategoryGap: '25%',
                    barWidth: 16,
                    emphasis: {
                        disabled: true
                    },
                    itemStyle: {
                        borderRadius: [
                            5,
                            5,
                            5,
                            5
                        ],
                        color: function(param) {
                            var data = param.data;
                            return _this.motivatorColor(data.id, data.percentage);
                        }
                    },
                    tooltip: {
                        formatter: function(param) {
                            var data = param.data;
                            return "".concat(data.motivator, ": ").concat(data.percentage, "%");
                        }
                    }
                }
            ],
            dataset: {
                dimensions: [
                    'motivator',
                    'percentage'
                ],
                source: data
            }
        }, _define_property(_obj, _class_private_field_get(_this, _valueAxis), _object_spread({}, _class_private_field_get(_this, _optionPresets).VALUE_AXIS)), _define_property(_obj, _class_private_field_get(_this, _labelAxis), _object_spread({}, _class_private_field_get(_this, _optionPresets).LABEL_AXIS)), _define_property(_obj, "media", [
            {
                option: _define_property({
                    series: [
                        {
                            type: 'bar',
                            label: _object_spread({
                                show: true
                            }, _class_private_field_get(_this, _percentageLabel))
                        }
                    ]
                }, _class_private_field_get(_this, _labelAxis), {
                    grid: {
                        left: 10,
                        right: 40
                    },
                    axisLabel: {
                        fontSize: 14,
                        width: 100
                    }
                })
            },
            {
                query: {
                    maxWidth: 400
                },
                option: _define_property({
                    grid: {
                        left: 5,
                        right: 40
                    },
                    series: [
                        {
                            type: 'bar',
                            label: _object_spread({
                                show: true
                            }, _class_private_field_get(_this, _percentageLabel))
                        }
                    ]
                }, _class_private_field_get(_this, _labelAxis), {
                    axisLabel: {
                        fontSize: 10,
                        width: 75
                    }
                })
            },
            {
                query: {
                    maxWidth: 250
                },
                option: {
                    grid: {
                        left: 0,
                        right: 0
                    },
                    series: [
                        {
                            type: 'bar',
                            label: {
                                show: false
                            }
                        }
                    ]
                }
            }
        ]), _obj), opts);
        return _this;
    }
    _create_class(MotivatorsBarChart, [
        {
            key: "applyDataset",
            value: function applyDataset() {
                var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                this.applyOptions({
                    dataset: _object_spread_props(_object_spread({}, this.options.dataset), {
                        source: data
                    })
                });
            }
        }
    ]);
    return MotivatorsBarChart;
}(MotivatorChart);

//# sourceMappingURL=MotivatorsBarChart.js.map